import React from "react";

import { Navigate, useLocation} from "react-router-dom";
import APIService from "../Services/API/APIService";
import {
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
  Message,
  Icon,
} from "semantic-ui-react";
import * as Msal from "msal";

import NavHeader from '../Components/NavHeader'
const AdminLogin = (props) => {
  const location = useLocation()
  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({ show: false, message: "" });
  let msalConfig = {
    auth: {
      clientId: "9026c5e1-766e-4ee6-8789-da84c7d18dbd",
      authority:
        "https://login.microsoftonline.com/ba440370-7b6d-4c5d-98f5-bdd9e6d1e4f1", //This is your tenant info
        redirectURI: "http://localhost:3000/login",
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
    },
  };

  let myMSALObj = new Msal.UserAgentApplication(msalConfig);

  let requestObj = {
    scopes: ["api://9026c5e1-766e-4ee6-8789-da84c7d18dbd/user.read"],
  };
 
  let { from } =  location.state || { from: {pathname : '/'} };

  const _microsoftLogin = async () => {
    try {
      setLoading(true);
      let accessResponse = null;
  
      try {
        accessResponse = await myMSALObj.acquireTokenSilent(requestObj);

      } catch (error) {

        accessResponse = await myMSALObj.loginPopup(requestObj);
        if (!accessResponse.accessToken) {
          accessResponse = await myMSALObj.acquireTokenSilent(requestObj);
        }
      }

      APIService.storeToken(accessResponse.accessToken);

     let response = await APIService.postData("/auth/guestHouseAdmin", {});
        
       setLoading(false);
       afterLogin(response);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const afterLogin = async (loginResponse) => {
    if (!loginResponse) {
      setAlert({ show: true, message: "Login failed" });
      return;
    }

    APIService.storeToken(loginResponse.token);

    setRedirectToReferrer(true);
  };

 if (redirectToReferrer) {
    return  <Navigate to={from}  replace />
 
 } 

  return (
    <div>
      <NavHeader/>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Grid centered style={{ marginTop: 50 }}>
   

        {alert?.show && (
          <Card centered>
            <Message warning>
              {/* <Message.Header>Error</Message.Header> */}
              <p>{alert.message}</p>
            </Message>
          </Card>
        )}

        <Grid.Row>
          <Grid stackable relaxed="very">
            <Grid.Row>
              <Grid.Column verticalAlign="middle">
                <Card centered>
                  <Card.Content>
                    <Button
                      onClick={_microsoftLogin}
                
                      style={{ backgroundColor : '#26f09e',color:'#000000'}}
                    >
                      <Icon name="windows" /> Login With Microsoft
                    </Button>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Row>
      </Grid>

    </div>
  );
};

export default AdminLogin;